
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
import Skeleton from 'react-loading-skeleton'; 
import 'react-loading-skeleton/dist/skeleton.css';
import useExecutiveCollection from '../CharterAdmin/libs/fetchExecutiveBus';
import './AllCharter.css';


const Executivecharter = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;
    const { executiveData, isLoading, isError } = useExecutiveCollection(currentPage);

    useEffect(() => {
        if (executiveData && executiveData.currentPage) {
            setCurrentPage(executiveData.currentPage);
        }
    }, [executiveData]);

    const handleScroll = useCallback(() => {
        if (
            window.innerHeight + document.documentElement.scrollTop === 
            document.documentElement.offsetHeight
        ) {
            if (currentPage < executiveData.totalPages) {
              
            }
        }
    }, [currentPage, executiveData]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    if (isError) {
        return <div className='error'>No Executive Bus available now</div>;
    }

    if (isLoading) {
        return (
            <div className='vehicle-collection'>
                <span>
                    <Link to='/charteringservice'>Home</Link>
                    <MdKeyboardDoubleArrowRight />
                    <h3>Executives Buses</h3>
                </span>
                <h3>EXECUTIVES BUSES COLLECTION</h3>
                <div className="wrapper">
                    {[...Array(8)].map((_, index) => (
                        <div key={index} className="vehicle-list">
                            <Skeleton height={250} width={300} count={1} />
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    const { executiveBus, totalExecutiveBus } = executiveData; 

    if (!executiveBus || executiveBus.length === 0) {
        return <div>No executives bus available</div>; 
    }

    const handlePrevPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
      };
    
      const handleNextPage = () => {
        setCurrentPage((prevPage) => Math.min(prevPage + 1, executiveData.totalPages));
      };

    const totalPages = Math.ceil(totalExecutiveBus / itemsPerPage);
    const startIndex = Math.min((currentPage - 1) * itemsPerPage + 1, totalExecutiveBus);
    const endIndex = Math.min(startIndex + itemsPerPage - 1, totalExecutiveBus);
  

    const clampWords = (text, maxWords) => {
        const words = text.split(' ');
        const clampedText = words.slice(0, maxWords).join(' ');
        return words.length > maxWords ? `${clampedText}...` : clampedText;
    };

    return (
        <div className='vehicle-collection'>
            <span>
                <Link to='/charteringservice'>Home</Link>
                <MdKeyboardDoubleArrowRight />
                <h3>Executives Buses</h3>
            </span>
            <h3>EXECUTIVES BUSES COLLECTION</h3>
            <div className="wrapper">
               {executiveBus.map(executive => (
                    <div key={executive._id} className="vehicle-list">
                        <img src={executive.images[0]} alt={executive.vehicleModel} />
                        <h4>{executive.vehicleModel}</h4>
                        <h3><p>Price Per Day:</p>{executive.pricingPerDay
                      ? (executive.pricingPerDay ).toLocaleString("en-US", {
                          style: "currency",
                          currency: "NGN",
                        })
                      : ""}</h3>
                        <p>{executive.isHired ? 'Not available' : 'Available'}</p>
                        <p>Location  {executive.state}</p>
                        <p>{clampWords(executive.description, 5)}<Link to={`/car-details/${executive._id}`}>view details</Link></p>
                    </div>
                ))}
            </div>
            <div className="vehicle-collection-pagination">
                <span>{`Showing ${startIndex} - ${endIndex} of ${totalExecutiveBus}`}</span>
                <div className="btn">
                    <button onClick={handlePrevPage} disabled={currentPage === 1}>
                        Prev
                    </button>
                    <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Executivecharter;
